import { Alert, Modal } from "react-bootstrap";
import { Message } from "../../utils/types";
import ModalFooter from "../modal/ModalFooter";
import ModalHeader from "../modal/ModalHeader";
import Loading from "../../utils/Loding";

function ModalNotificaton(props:any) {
  const { title, messages, show, setShow, isLoading, handleParentClose } = props;

  const handleClose = () => {
    if (handleParentClose) handleParentClose();
    setShow(false);
  }

  return (
    <Modal show={show} onHide={handleClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <ModalHeader title={title} />
      <Modal.Body>
        {(() => {
          if (isLoading) {
            return <Loading />;
          } else {
            return (
              messages.map((message:Message, index:number) => {
                return (
                  <Alert key={index} variant={message.type}>
                    <span>{message.message}</span>
                  </Alert>
                );
              })
            );
          }
        })()}
      </Modal.Body>
      <ModalFooter close={handleClose}/>
    </Modal>
  );
}
export default ModalNotificaton;